import { render, staticRenderFns } from "./waitSendBackOrders.vue?vue&type=template&id=05cce5f5&scoped=true"
import script from "./waitSendBackOrders.vue?vue&type=script&lang=js"
export * from "./waitSendBackOrders.vue?vue&type=script&lang=js"
import style0 from "./waitSendBackOrders.vue?vue&type=style&index=0&id=05cce5f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cce5f5",
  null
  
)

export default component.exports